"use client";

import Image from "next/image";

export default function SocialLoginButton({
	provider,
	imageUrl,
	onClick,
}: {
	provider: string;
	imageUrl: string;
	onClick: () => void;
}) {
	return (
		<button
			onClick={onClick}
			aria-label={`Sign up with ${provider}`}
			className="rounded border bg-muted p-2"
		>
			<Image
				src={imageUrl}
				alt={""}
				width={24}
				height={24}
				quality={20}
				priority
				className="object-contain"
			/>
		</button>
	);
}
